import script from "./RemoveOrganizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveOrganizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./RemoveOrganizationModal.vue?vue&type=style&index=0&id=92c4e5b0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92c4e5b0"]])

export default __exports__